<script setup lang="ts">
// Chromeless provider-return / callback host (contract 05 §10).
</script>

<template>
  <div class="blank-layout grid min-h-dvh place-items-center bg-canvas p-lg"><slot /></div>
</template>
